import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../../lib/Context';
import InvisibleInput from '../PageElements/InvisibleInput';
import '../../../lib/css/EventCompetitor.css';
import '../../../lib/css/HomePageCompetitor.css';
import Spinner from 'react-bootstrap/Spinner';
import SwitchEventAdjudicator from './EventElements/SwitchEventAdjudicator';
import ProofPhotoModal from '../../Modals/ProofPhotoModal'

const EventCompetitor = (props) => {
    let {
        competitorObject, adjudicators, index, competitors, isLoading, setIsLoading,
        getCompetitors
    } = props;
    const { API_LINK, type, event, setEvents, isLiveEvent } = useContext(Context);
    const [showPhotoModal, setShowPhotoModal] = useState();
    const [showScores, setShowScores] = useState(false);
    let [adjudicator, setAdjudicator] = useState({});
    let [eventScores, setEventScores] = useState({});
    let [exerciseProofs, setExerciseProofs] = useState({});
    let [currentSlug, setCurrentSlug] = useState('');
    let [profilePicture, setProfilePicture] = useState('');
    let [pictureInfo, setPictureInfo] = useState('')
    let [total, setTotal] = useState(0);
    let [time, setTime] = useState(0);

    let userType = type;

    const handleDisplayScores = () => {
        // Only allow click-to-show-scores on mobile screens (width < 768px)
        if (window.innerWidth < 768) {
            setShowScores(prev => !prev)
        }
    }

    useEffect(() => {
        // Get the adjudicator ID
        setProfilePicture(competitorObject.profilePicture);
        setEventScores({ ...competitorObject.exercise_scores });
        setExerciseProofs({ ...competitorObject.exercise_proofs })
        setTotal(competitorObject.total);

        const timeValue = competitorObject.exercise_scores['time'];
        setTime((timeValue !== null && timeValue !== undefined && !isNaN(timeValue)) ? timeValue : 0);

        for (let i = 0; i < event?.competitors.length; i++) {
            if (event?.competitors[i].userID === competitorObject._id) {
                let adjudicatorID = event?.competitors[i].adjudicator.userID;
                // Find the competitor and set the relevant adjudicator to the wave
                for (let j = 0; j < adjudicators.length; j++) {
                    if (adjudicators[j]._id === adjudicatorID) {
                        setAdjudicator(adjudicators[j]);
                    }
                }
            }
        }

    }, [competitorObject._id, event.competitors, adjudicators, event.exercises, competitorObject]);

    const togglePhotoModal = (slug) => {
        let firstname = competitorObject.firstname;
        let lastname = competitorObject.lastname;
        let score = isLiveEvent ? eventScores[slug] : formatTime(eventScores[slug]);
        let pictureInfo = `${firstname} ${lastname} achieved ${score}`;
        setPictureInfo(pictureInfo);
        setCurrentSlug(slug);
        setShowPhotoModal(!showPhotoModal);
    }

    const updateCompetitorScore = async () => {
        const scores = { ...eventScores }
        scores['time'] = time
        setIsLoading(true);
        const response = await fetch(API_LINK + '/update-competitor-score', {
            method: 'POST',
            body: JSON.stringify({
                competitorID: competitorObject._id, exercise_scores: scores, eventID: event._id, competitors,
                isLiveEvent
            }),
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include'
        })
        if (response.ok) {
            response.json().then(async data => {
                setEvents(data.events);
                getCompetitors(event._id);
            });
        }
    }

    const handleChangeScore = (event) => {
        let slug = event.target.name;
        let value = event.target.value;

        if (!isLiveEvent) {
            // Virtual events: handle as time input
            const rawScore = value.replace(/:/g, ""); // Get raw input as string
            let score = rawScore.replace(/^0+/, "")
            if (/^\d*$/.test(score)) { // Only allow numeric input
                if (score.length <= 6) { // Allow up to 6 digits for HHMMSS
                    let newMap = { ...eventScores };
                    newMap[slug] = parseInt(score) || 0;
                    setEventScores(newMap);
                }
            }
        } else {
            // Live events: handle as numeric input
            // Only parse the value if it's not empty
            if (value !== '') {
                value = parseInt(value, 10);
                if (isNaN(value)) {
                    value = 0; // Default to zero if parsing fails
                }
            } else {
                value = ''; // Keep empty string if input is empty
            }

            let newMap = { ...eventScores };
            newMap[slug] = value;
            setEventScores(newMap);
        }
    }

    const handleChangeCVTime = (event) => {
        let slug = event.target.name;
        let value = event.target.value;
        // Remove colons and format as raw number
        const rawScore = value.replace(/:/g, "");
        const score = rawScore.replace(/^0+/, "");
        
        if (/^\d*$/.test(score)) { // Only allow numeric input
            if (score.length <= 6) { // Allow up to 6 digits for HHMMSS
                let newMap = { ...eventScores };
                newMap[slug] = parseInt(score) || 0;
                setEventScores(newMap);
            }
        }
    }

    const handleChangeTime = (event) => {
        let value = event.target.value;
        value = value.replace(/:/g, "");
        // Remove leading zeros
        if (value.length > 1 && value.startsWith('0')) {
            value = value.replace(/^0+/, '');
        }
        if (value.length <= 5) {
            setTime(value.replace(/[^0-9]/g, ''));
        }

    }

    const formatTime = (value) => {
        // Handle NaN, null, undefined, or empty values
        if (value === null || value === undefined || value === '' || isNaN(value)) {
            return '00:00:00';
        }
        
        // Ensure input is a string, pad to 5 characters (if it's shorter)
        const paddedInput = String(value).padStart(5, '0');

        // Extract hours, minutes, seconds
        const hours = parseInt(paddedInput.slice(0, paddedInput.length - 4), 10);
        const minutes = parseInt(paddedInput.slice(-4, -2), 10);
        const seconds = parseInt(paddedInput.slice(-2), 10);

        // Return the formatted time in H:MM:SS
        return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    };


    return (
        <tr>
            <td colSpan={showScores ? 2 : 1}>
                <div style={{ color: 'white' }}>
                    <table>
                        <tbody>
                            <tr>
                                <td style={{ width: '45px', verticalAlign: 'top' }}>
                                    <img
                                        src={profilePicture ? profilePicture
                                            :
                                            "https://x-tron-images.s3.us-east-1.amazonaws.com/1734434622097tron-pic.png"}
                                        alt="Profile"
                                        style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            marginRight: '15px'
                                        }}
                                        className="mobile-small-image"
                                    />
                                    <ProofPhotoModal showPhotoModal={showPhotoModal} togglePhotoModal={togglePhotoModal}
                                        photoURL={'https://x-tron-images.s3.us-east-1.amazonaws.com/1734525240207yhwh.jpg'}
                                        slug={currentSlug} exerciseProofs={exerciseProofs} pictureInfo={pictureInfo}
                                    />
                                </td>
                                <td style={{ paddingTop: '0px' }}>
                                    <span onClick={handleDisplayScores} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                                        {competitorObject?.firstname} {competitorObject.lastname}
                                    </span>
                                    {showScores &&
                                        <div className="mobile-only" style={{
                                            width: '100%',
                                            lineHeight: '1.4em',
                                            textAlign: 'left',
                                            color: '#26ffe2',
                                            fontSize: '0.9em'
                                        }}>
                                            {event.exercises.map((exercise, index) => {
                                                let type = exercise.type;
                                                let slug = exercise.name.toLowerCase().replace(/\s+/g, '_');
                                                if (type === 'Weights') {
                                                    // Get the weight for this competitor and exercise
                                                    let weight = '';
                                                    if (isLiveEvent && event.competitors) {
                                                        const competitor = event.competitors.find(c => c.userID === competitorObject._id);
                                                        if (competitor && competitor.exercise_weights && competitor.exercise_weights[slug]) {
                                                            weight = competitor.exercise_weights[slug];
                                                        }
                                                    }

                                                    return (
                                                        <div key={slug}>
                                                            <div style={{ marginBottom: '4px', lineHeight: '1.1' }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px' }}>
                                                                    <span style={{ color: 'white', fontWeight: 'bold' }}>{exercise.name}</span>
                                                                    {userType === 'admin' && !isLoading ? (
                                                                        <input
                                                                            value={eventScores[slug] || 0}
                                                                            onChange={handleChangeScore}
                                                                            onBlur={updateCompetitorScore}
                                                                            name={slug}
                                                                            type="text"
                                                                            style={{
                                                                                background: 'transparent',
                                                                                border: 'none',
                                                                                color: 'white',
                                                                                textAlign: 'right',
                                                                                width: '50px',
                                                                                fontSize: '0.9em',
                                                                                outline: 'none',
                                                                                paddingRight: '2px',
                                                                                boxSizing: 'border-box'
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <span style={{ color: 'white' }}>{eventScores[slug] || 0}</span>
                                                                    )}
                                                                </div>
                                                                <div style={{ marginTop: '0px' }}>
                                                                    <span style={{ color: 'white', fontSize: '0.85em' }}>
                                                                        {weight ? <span style={{ color: '#26ffe2' }}>{weight}kg</span> : ''} × {exercise.reps}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {index < event.exercises.length - 1 && (
                                                                <hr style={{ border: '1px solid #26ffe2', margin: '8px 0', opacity: '0.3' }} />
                                                            )}
                                                        </div>
                                                    )
                } else if (type === 'CV') {
                    // Check exercise configuration: distance set = collect time, time set = collect distance
                    const isDistanceMode = exercise.distance !== null && exercise.distance !== undefined && exercise.distance !== '';
                    const isTimeMode = exercise.time !== null && exercise.time !== undefined && exercise.time !== '';
                    const displayValue = isDistanceMode ? formatTime(eventScores[slug]) : eventScores[slug];
                    return (
                        <div key={slug}>
                            <div style={{ marginBottom: '4px', lineHeight: '1.1' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px' }}>
                                    <span style={{ color: 'white', fontWeight: 'bold' }}>{exercise.name}</span>
                                    {userType === 'admin' && !isLoading ? (
                                                                        <input
                                                                            value={displayValue || 0}
                                                                            onChange={isDistanceMode ? handleChangeCVTime : handleChangeScore}
                                                                            onBlur={updateCompetitorScore}
                                                                            name={slug}
                                                                            type="text"
                                                                            style={{
                                                                                background: 'transparent',
                                                                                border: 'none',
                                                                                color: 'white',
                                                                                textAlign: 'right',
                                                                                width: '50px',
                                                                                fontSize: '0.9em',
                                                                                outline: 'none',
                                                                                paddingRight: '2px',
                                                                                boxSizing: 'border-box'
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <span style={{ color: 'white' }}>{displayValue || 0}</span>
                                                                    )}
                                                                </div>
                                                                <div style={{ marginTop: '0px' }}>
                                                                    <span style={{ color: 'white', fontSize: '0.85em' }}>
                                                                        {isDistanceMode ? exercise.distance + ' km - Best Time' : isTimeMode ? exercise.time + ' mins - Distance' : ''}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {index < event.exercises.length - 1 && (
                                                                <hr style={{ border: '1px solid #26ffe2', margin: '8px 0', opacity: '0.3' }} />
                                                            )}
                                                        </div>
                                                    )
                                                } else {
                                                    return isLiveEvent && (
                                                        <div key={slug}>
                                                            <div style={{ marginBottom: '4px', lineHeight: '1.1' }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <span style={{ color: 'white', fontWeight: 'bold' }}>Total {exercise.name}</span>
                                                                    {userType === 'admin' && !isLoading ? (
                                                                        <input
                                                                            value={formatTime(time) || 0}
                                                                            onChange={handleChangeTime}
                                                                            onBlur={updateCompetitorScore}
                                                                            name={slug}
                                                                            type="text"
                                                                            style={{
                                                                                background: 'transparent',
                                                                                border: 'none',
                                                                                color: 'white',
                                                                                textAlign: 'right',
                                                                                width: '58px',
                                                                                fontSize: '0.9em',
                                                                                outline: 'none',
                                                                                paddingRight: '6px',
                                                                                boxSizing: 'border-box'
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <span style={{ color: 'white' }}>{formatTime(time) || 0}</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {index < event.exercises.length - 1 && (
                                                                <hr style={{ border: '1px solid #26ffe2', margin: '8px 0', opacity: '0.3' }} />
                                                            )}
                                                        </div>
                                                    )
                                                }
                                            })}
                                            <div style={{ marginTop: '15px', paddingTop: '10px', borderTop: '1px solid #26ffe2', display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: 'white', fontSize: '1.1em' }}>Total Score:</span>
                                                <span style={{ color: 'white', fontSize: '1.1em', fontWeight: 'bold' }}>
                                                    {isLoading ?
                                                        <Spinner animation="border" size="sm" />
                                                        :
                                                        total || 0
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </td>
            {isLiveEvent &&
                <td className="mobile-hide" style={{ paddingRight: '40px' }}>
                    {type === 'admin' ?
                        <SwitchEventAdjudicator event={event} competitorObject={competitorObject} index={index}
                            getCompetitors={getCompetitors} />
                        :
                        adjudicator?.firstname && adjudicator?.firstname.charAt(0) + '.' + adjudicator.lastname
                    }
                </td>
            }
            {event.exercises.map((exercise) => {
                let type = exercise.type;
                let slug = exercise.name.toLowerCase().replace(/\s+/g, '_');
                if (type === 'Weights') {
                    return (
                        <React.Fragment key={event._id + '-' + slug + '-' + index + '-' + competitorObject._id}>
                            <td className="mobile-hide" style={{ fontSize: '0.8em' }}>
                                {isLiveEvent && event.competitors.map((competitor) => {
                                    if (competitor.userID === competitorObject._id) {
                                        return <span key={competitor.userID} style={{ color: '#26ffe2' }}>
                                            {competitor.exercise_weights[slug] + 'kg'}
                                        </span>
                                    } else {
                                        return '';
                                    }
                                })}
                            </td>
                            <td className="mobile-hide" style={{
                                color: eventScores[slug] !== 0 && eventScores[slug] && 'white',
                                fontSize: '1.4em'
                            }}>
                                {userType === 'admin' && !isLoading ?
                                    <InvisibleInput
                                        value={eventScores[slug] || 0}
                                        onInput={handleChangeScore}
                                        onBlur={updateCompetitorScore}
                                        name={slug} type={"text"}
                                        weight={'bold'}
                                        disabled={false}
                                    />
                                    :
                                    <InvisibleInput
                                        value={eventScores[slug] || 0}
                                        onInput={() => { }}
                                        onBlur={() => { }}
                                        name={slug} type={"text"}
                                        weight={'bold'}
                                        disabled={true}
                                    />
                                }

                            </td>
                        </React.Fragment>
                    )
                } else if (type === 'CV') {
                    // Check exercise configuration: distance set = collect time, time set = collect distance
                    const isDistanceMode = exercise.distance !== null && exercise.distance !== undefined && exercise.distance !== '';
                    const isTimeMode = exercise.time !== null && exercise.time !== undefined && exercise.time !== '';
                    const displayValue = isDistanceMode ? formatTime(eventScores[slug]) : eventScores[slug];
                    return (
                        <td key={slug + '-' + index + '-' + competitorObject._id} className="mobile-hide" style={{
                            color: eventScores[slug] !== 0 && eventScores[slug] && 'white',
                            fontSize: '1.4em'
                        }}>
                            {userType === 'admin' && !isLoading ?
                                <InvisibleInput
                                    value={displayValue || 0}
                                    onInput={isDistanceMode ? handleChangeCVTime : handleChangeScore}
                                    onBlur={updateCompetitorScore} // Use handleBlur here
                                    name={slug}
                                    type={"text"}
                                    weight={'bold'}
                                    disabled={false}
                                />
                                :
                                <InvisibleInput
                                    value={displayValue || 0}
                                    onInput={() => { }}
                                    onBlur={() => { }} // Use handleBlur here
                                    name={slug}
                                    type={"text"}
                                    weight={'bold'}
                                    onClick={() => togglePhotoModal(slug)}
                                    disabled={true}
                                />

                            }
                        </td>
                    )
                } else {
                    return isLiveEvent && <td key={slug + '-' + index + '-' + competitorObject._id} className="mobile-hide" style={{
                        color: eventScores[slug] !== 0 && eventScores[slug] && 'white',
                        fontSize: '1.4em'
                    }}>
                        <InvisibleInput
                            value={formatTime(time) || 0}
                            onInput={handleChangeTime}
                            onBlur={updateCompetitorScore} // Use handleBlur here
                            name={slug}
                            type={"text"}
                            weight={'bold'}
                            disabled={false}
                        />
                    </td>
                }
            })}
            <td style={{ textAlign: 'right', color: 'white', fontWeight: 'bold', fontSize: '1.8em' }} className={showScores ? 'mobile-hide' : ''}>
                {isLoading ?
                    <Spinner animation="border" size="sm" />
                    :
                    total || 0
                }
            </td>
        </tr>
    )
}

export default EventCompetitor